// Implementação web de `PlataformaRecursos` (plataforma/tipos.ts): no navegador (inclusive no iPhone) tudo existe.

/** Sorteios aparecem no web (o recorte é só dos apps nativos das lojas, iOS e Android). */
export function sorteiosVisiveis(): boolean {
  return true;
}

/** Prêmios por colocação/disputa aparecem no web (o recorte é só dos apps nativos das lojas). */
export function premiosDeDisputaVisiveis(): boolean {
  return true;
}
